import {
  AUTH_TOKEN_FAILED,
  AUTH_TOKEN_REQUEST,
  AUTH_TOKEN_SUCCESS,
  COMPANY_DETAILS_FORM,
  G2_CUSTOMER_SIGNUP_REQUEST,
  GET_ALL_STATE_LIST,
  RESEND_EMAIL_FAILED,
  RESEND_EMAIL_REQUEST,
  RESEND_EMAIL_SUCCESS,
  SIGN_UP_FAILED_REQUEST,
  SIGN_UP_LOADING_REQUEST,
  SIGN_UP_SUCCESS,
  UPDATE_SIGN_UP_FORM,
} from "../constants";

const INITIAL_STATE = {
  current: {},
  signUpData: {},
  isLoading: false,
  isSignUp: false,
  createAccount: {},
  companyDetailsData: {},
  stateObject: {},
  tokenToken: {},
  emailVerification: {},
  g2CustomerOrUserSignupParams: {},
};

const signUpReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SIGN_UP_LOADING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SIGN_UP_FAILED_REQUEST:
      return {
        ...state,
        isLoading: false,
      };
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        signUpData: action.payload,
        isLoading: false,
        isSignUp: true,
      };
    case GET_ALL_STATE_LIST:
      return {
        ...state,
        stateObject: action.payload,
      };
    case UPDATE_SIGN_UP_FORM:
      return {
        ...state,
        createAccount: action.payload,
      };
    case COMPANY_DETAILS_FORM:
      return {
        ...state,
        companyDetailsData: action.payload,
      };
    case AUTH_TOKEN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case AUTH_TOKEN_SUCCESS:
      return {
        ...state,
        tokenToken: action.payload,
      };
    case AUTH_TOKEN_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case RESEND_EMAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        emailVerification: action.payload,
      };
    case RESEND_EMAIL_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case G2_CUSTOMER_SIGNUP_REQUEST:
      return {
        ...state,
        isLoading: false,
        g2CustomerOrUserSignupParams: action.payload,
      };
    default:
      return state;
  }
};

export default signUpReducer;
